// extracted by mini-css-extract-plugin
export default {"JobAds":"BuySellAds_JobAds__EA3bx","close_button":"BuySellAds_close_button__ZauCE","ads_mod":"BuySellAds_ads_mod__2ENZC","fav_pop_up":"BuySellAds_fav_pop_up__hrVIx"};